import { render, staticRenderFns } from "./Summarize.vue?vue&type=template&id=27946c3e&scoped=true"
import script from "./Summarize.vue?vue&type=script&lang=js"
export * from "./Summarize.vue?vue&type=script&lang=js"
import style0 from "./Summarize.vue?vue&type=style&index=0&id=27946c3e&prod&lang=scss"
import style1 from "./Summarize.vue?vue&type=style&index=1&id=27946c3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27946c3e",
  null
  
)

export default component.exports